/************************************** Module ***********************************************/
import angular from 'angular';
import "reflect-metadata";
import 'angular-translate';

/************************************** Less ***********************************************/
import './board-quality.less';

import 'bootstrap/dist/css/bootstrap.css';

/*************************************** Directive ************************************************/
import { module_name as qpPictureLoading } from "@directives/qp-picture-loading/qp-picture-loading.module";


/************************************** Module ***********************************************/
let pageModule = angular.module("board-quality-page", [qpPictureLoading, 'pascalprecht.translate']);




